import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { AsyncModel, AsyncModelClose } from '../AsyncModel/AsyncModel';
import ReactLoading from 'react-loading';
import { FormattedMessage } from 'react-intl';
import { CusButton } from '../../Components/From/Button';
import { CusInput } from '../../Components/From/Input';
import { Global } from '../../App';
import PerfectScrollbar from 'react-perfect-scrollbar';
import moment from 'moment';

// switch lang
import { langStringToCode } from '../../Share/Tools/switchLang';
// api
import { getAllStore, getStoreAllStaff, getStaffInfo, postSetSupport } from '../../Api/staff/GetStaffInfo';
import Tool_storeName from '../Tools/Tool_storeName';
import { placeholder } from 'lodash/fp';

/**
 * @param {object} props
 *
 * 本次步驟會影響的global state
 * 1-1
 * currentCheckOrderStep => '2'
 * checkOrderBranch
 * checkOrderGroup
 * checkOrderStaff
 */
function StaffCheckStep_1(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, setState] = useState({
    searchMsg: '',
    currShow: handleShow(),
    currBranch: globalState.staffInfo.checkOrderBranch,
    branchInfo: [],
    currGroup: globalState.staffInfo.checkOrderGroup,
    groupInfo: [],
    currStaff: globalState.staffInfo.checkOrderStaff,
    staffInfo: [],
    filterStaff: []
  });

  function handleShow() {
    const {
      checkOrderBranch,
      checkOrderGroup,
      checkOrderStaff
    } = globalState.staffInfo;
    // step_2回來的
    if (checkOrderBranch && checkOrderGroup && !checkOrderStaff) return 'selectStaff';
    // 原流程
    if (checkOrderBranch) return 'selectGroup';

    if (checkOrderBranch && checkOrderGroup) return 'selectStaff';

    if (checkOrderBranch && !checkOrderGroup && !checkOrderStaff)
      return 'selectGroup';

    if (!checkOrderBranch && !checkOrderGroup && !checkOrderStaff)
      return 'selectBranch';
  }
  // get store
  async function apiAllStore(langId) {
    try {
      const waittingAlert = AsyncModel({
        content: (
          <div className="w-100 d-flex justify-content-center">
            <ReactLoading
              type="spokes"
              color="#ccc"
              height="100px"
              width="100px"
            />
          </div>
        ),
        showConfirmBtn: false
      });
      const res = await getAllStore(langId);

      AsyncModelClose();

      const { errCode, branch } = res.data;

      if (errCode == 200) {
        const newStore = branch.map(e => ({
          branchName: e.name,
          branchCode: e.id
        }));

        return newStore;
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });

        props.history.push('/staff/error');
      }
    } catch (err) {
      AsyncModelClose();

      console.error('all store error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 404 }]
      });

      props.history.push('/staff/error');
    }
  }
  // get all staff
  async function apiAllStaff(storeId) {
    try {
      const waittingAlert = AsyncModel({
        content: (
          <div className="w-100 d-flex justify-content-center">
            <ReactLoading
              type="spokes"
              color="#ccc"
              height="100px"
              width="100px"
            />
          </div>
        ),
        showConfirmBtn: false
      });
      const res = await getStoreAllStaff(storeId);

      AsyncModelClose();

      const { errCode, groupList } = res.data;

      if (errCode == 200) {
        const newGroup = groupList.map(e => ({
          groupName: e.name,
          groupCode: e.id,
          waiterList: e.waiterList
        }));

        return newGroup;
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });

        props.history.push('/staff/error');
      }
    } catch (err) {
      AsyncModelClose();

      console.error('get group error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 411 }]
      });

      props.history.push('/staff/error');
    }
  }

  // get staff info
  async function apiStaffInfo(workNum) {
    try {
      const waittingAlert = AsyncModel({
        content: (
          <div className="w-100 d-flex justify-content-center">
            <ReactLoading
              type="spokes"
              color="#ccc"
              height="100px"
              width="100px"
            />
          </div>
        ),
        showConfirmBtn: false
      });
      const res = await getStaffInfo(workNum);

      AsyncModelClose();

      const { errCode } = res.data;

      if (errCode == 200 || errCode == 4122 || errCode == 4123 || errCode == 4124) {
        return res.data;
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });
        
        props.history.push('/staff/error');
      }
    } catch (err) {
      AsyncModelClose();

      console.error('get group error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 412 }]
      });

      props.history.push('/staff/error');
    }
  }

  // staff join support group
  async function apiStaffSetSupport(storeId, workNum, waiterName) {
    try {
      const waittingAlert = AsyncModel({
        content: (
          <div className="w-100 d-flex justify-content-center">
            <ReactLoading
              type="spokes"
              color="#ccc"
              height="100px"
              width="100px"
            />
          </div>
        ),
        showConfirmBtn: false
      });
      const res = await postSetSupport({
        storeID: storeId,
        work_num: workNum,
        waiterName
      });

      AsyncModelClose();

      const { errCode, response } = res.data;
      if (errCode == 200) {
        return response;
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });

        props.history.push('/staff/error');
      }
    } catch (err) {
      AsyncModelClose();

      console.error('get group error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 412 }]
      });

      props.history.push('/staff/error');
    }
  }

  useEffect(() => {
    const { checkOrderData } = globalState.staffInfo;
    console.log(globalState)

    if (
      state.currBranch &&
      state.currGroup &&
      state.currStaff &&
      checkOrderData
    ) {
      dispatchGlobal({
        type: 'UPDATE',
        payload: [
          {
            key: 'staffInfo',
            val: {
              ...globalState.staffInfo,
              currentCheckOrderStep: '3',
              checkOrderBranch: state.currBranch,
              checkOrderGroup: state.currGroup,
              checkOrderStaff: state.currStaff
            }
          }
        ]
      });
    } else if (
      state.currBranch &&
      state.currGroup &&
      state.currStaff &&
      !checkOrderData
    ) {
      if (functionType() === 'staffCheckOrder') {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [
            {
              key: 'staffInfo',
              val: {
                ...globalState.staffInfo,
                currentCheckOrderStep: '2',
                checkOrderBranch: state.currBranch,
                checkOrderGroup: state.currGroup,
                checkOrderStaff: state.currStaff
              }
            }
          ]
        });
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [
            {
              key: 'staffInfo',
              val: {
                ...globalState.staffInfo,
                currentTakeOrderStep: '2',
                checkOrderBranch: state.currBranch,
                checkOrderGroup: state.currGroup,
                checkOrderStaff: state.currStaff
              }
            }
          ]
        });
      }
    }
  }, [state]);

  const functionType = () => {
    let pathname = window.location.pathname.replace(/<[^>]*>|/g, '');

    if (pathname.toLowerCase().indexOf('stafftakeorder') > -1) {
      return 'staffTakeOrder';
    } else {
      return 'staffCheckOrder';
    }
  }

  // call api
  useEffect(() => {
    const { langType } = globalState;

    if (state.currShow === 'selectBranch') {
      (async () => {
        let getAllStore = await apiAllStore(langStringToCode(langType));
        if (getAllStore) {
          setState(curr => {
            return {
              ...curr,
              branchInfo: getAllStore
            };
          });
        }
      })();
    } else if (state.currShow === 'selectGroup') {
      if (state.searchMsg) {
        let filterStaff = state.groupInfo.map(groupMap => {
          const findStaff = groupMap.waiterList.filter(fil => {
            return fil.work_num.indexOf(state.searchMsg) >= 0
          })
          if (findStaff.length) {
            return {
              ...groupMap,
              waiterList: findStaff
            }
          }
          // 去除undefined
        }).filter(f => f);
        // 6碼搜尋
        if (state.searchMsg.length === 6 && !filterStaff.length) {
          (async () => {
            const getStaffInfo = await apiStaffInfo(state.searchMsg);
            if (getStaffInfo) {
              const { errCode, response } = getStaffInfo;
              // 查無人員直接return
              if (errCode !== 4124) {
                const staffGroup = errCode === 200 ? globalState.langFile['pages.staffCheckOrder.step1.supportGroup'] : globalState.langFile[`errorMsg.errorCode_${errCode}`];
                filterStaff = [{
                  groupCode: null,
                  groupName: staffGroup,
                  waiterList: [{
                    id: null,
                    name: response.waiter_name,
                    work_num: state.searchMsg,
                    disable: errCode === 4122 || errCode === 4123,
                    isSupport: errCode === 200
                  }]
                }];
                setState(curr => {
                  return {
                    ...curr,
                    filterStaff
                  };
                });
              
              }
            }
          })();
        } else {
          setState(curr => {
            return {
              ...curr,
              filterStaff
            };
          });
        }
      } else {
        const { branchCode } = state.currBranch;
        (async () => {
          let getAllStaff = await apiAllStaff(branchCode);
          if (getAllStaff) {
            setState(curr => {
              return {
                ...curr,
                filterStaff: [],
                groupInfo: getAllStaff
              };
            });
          }
        })();
      }

    } else if (state.currShow === 'selectStaff') {
      if (state.currGroup.waiterList) {
        const newGroup = state.currGroup.waiterList.map(e => ({
          staffName: e.name,
          staffCode: e.id,
          staffNum: e.work_num
        }));
        setState(curr => {
          return {
            ...curr,
            staffInfo: newGroup
          };
        });
      }
    }
  }, [state.currShow, globalState.langType, state.searchMsg]);

  // 分店列表
  function BranchList() {
    return (
      <>
        {state.branchInfo.map((eachBranch, index) => (
          <CusButton
            key={index}
            className="Pages__branch p-3 store"
            onClick={() => {
              setState(curr => {
                return {
                  ...curr,
                  currBranch: eachBranch,
                  currShow: 'selectGroup'
                };
              });
              dispatchGlobal({
                type: 'UPDATE',
                payload: [
                  {
                    key: 'staffInfo',
                    val: {
                      ...globalState.staffInfo,
                      loginTime: moment().format('YYYY/MM/DD hh:mm:ss')
                    }
                  }
                ]
              });
            }}
            children={eachBranch.branchName}
          />
        ))}
      </>
    );
  }
  // 組別列表
  function GroupList() {
    return (
      <>
        {state.groupInfo.map((eachGroup, index) => (
          <CusButton
            key={index}
            className="Pages__branch p-3 group"
            onClick={() => {
              setState(curr => {
                return {
                  ...curr,
                  currGroup: eachGroup,
                  currShow: 'selectStaff'
                };
              });
            }}
            children={eachGroup.groupName}
          />
        ))}
      </>
    );
  }
  // 員工列表
  function StaffList() {
    return (
      <>
        {state.staffInfo.map((eachStaff, index) => (
          <CusButton
            key={index}
            className="Pages__branch p-3 staff"
            onClick={() => {
              setState(curr => {
                return {
                  ...curr,
                  currStaff: eachStaff
                };
              });
              setTimeout(() => {
                props.history.push('/staffSearchOrder')
              }, 1);
            }}
            children={
              <div className="d-flex flex-column justify-content-center align-items-center">
                <span className="Pages__branch__title">
                  {eachStaff.staffName}
                </span>
                <span className="Pages__branch__content">
                  {eachStaff.staffNum}
                </span>
              </div>
            }
          />
        ))}
      </>
    );
  }
  // 篩選員工列表
  function FilterStaffList() {
    return (
      <>
        {state.filterStaff.map(eachGroup => (
          eachGroup.waiterList.map((eachStaff, index) => (
            <CusButton
              key={index}
              className="Pages__branch p-3 staff"
              disabled={eachStaff.disable}
              onClick={() => {
                if (eachStaff.isSupport) {
                  const { branchCode } = state.currBranch;
                  (async () => {
                    const getWaiterId = await apiStaffSetSupport(branchCode, eachStaff.work_num, eachStaff.name);

                    if (getWaiterId) {
                      setState(curr => {
                        return {
                          ...curr,
                          searchMsg: '',
                          currGroup: {
                            groupCode: eachGroup.groupCode,
                            groupName: eachGroup.groupName,
                            waiterList: eachGroup.waiterList
                          },
                          currStaff: {
                            staffName: eachStaff.name,
                            staffCode: getWaiterId.waiterID,
                            staffNum: eachStaff.work_num
                          }
                        };
                      });
                      //線上內用點餐測報-門市登入後進入查詢訂單頁規則調整(測報171) 輸入工號也要去查詢訂單
                      setTimeout(() => {
                        props.history.push('/staffSearchOrder')
                      }, 1);
                    }
                  })();
                } else {
                  setState(curr => {
                    return {
                      ...curr,
                      searchMsg: '',
                      currGroup: {
                        groupCode: eachGroup.groupCode,
                        groupName: eachGroup.groupName,
                        waiterList: eachGroup.waiterList
                      },
                      currStaff: {
                        staffName: eachStaff.name,
                        staffCode: eachStaff.id,
                        staffNum: eachStaff.work_num
                      }
                    };
                  });
                  //線上內用點餐測報-門市登入後進入查詢訂單頁規則調整(測報171) 輸入工號也要去查詢訂單
                  setTimeout(() => {
                    props.history.push('/staffSearchOrder')
                  }, 1);
                }
              }}
              children={
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <span className={`Pages__branch__title${eachStaff.isSupport ? ' txtColorRed' : ''}`}>
                    {eachGroup.groupName}
                  </span>
                  <span className="Pages__branch__content">
                    {eachStaff.work_num} {eachStaff.name}
                  </span>
                </div>
              }
            />
          ))
        ))}
      </>
    );
  }
  return (
    <>
      <div className="Pages__space mb-3">
        <div className="Pages__space__item w-100 p-3 txtColorBrown text-center">
          {(() => {
            if (state.currShow === 'selectBranch')
              return (
                <FormattedMessage id="pages.staffCheckOrder.step1.selectBranchNotice" />
              );
            if (state.currShow === 'selectStaff' || state.searchMsg)
              return (
                <FormattedMessage id="pages.staffCheckOrder.step1.selectStaffNotice" />
              );
            if (state.currShow === 'selectGroup')
              return (
                <FormattedMessage id="pages.staffCheckOrder.step1.selectGroupNotice" />
              );
          })()}
         
        </div>
      </div>
      <div className="Pages__section">
        {state.currBranch && (
          <div className="Pages__state d-flex justify-content-center align-items-center p-2 mb-3">
            {state.currBranch ? (
              <Tool_storeName storeId={state.currBranch.branchCode} />
            ) : null}
            {state.currGroup ? (
              <span className="mr-2 ml-2">{state.currGroup.groupName}</span>
            ) : null}
            {state.currStaff ? (
              <span className="mr-2 ml-2">{state.currStaff.staffName}</span>
            ) : null}
          </div>
        )}
      </div>
      <div className="Pages__search">
        {state.currShow === 'selectGroup' && (
          <FormattedMessage
            id="pages.staffCheckOrder.step1.searchStaff"
            children={placeholderMsg => (
              <CusInput
                className="w-100"
                icon={<i className="icn ic_order_search__mobile" />}
                maxLength={6}
                type="num"
                placeholder={placeholderMsg}
                value={state.searchMsg}
                onChange={event => {
                  let val = event.target.value.trim();
                  // if (searchOnChange) {
                  //   searchOnChange(val);
                  // }
                  if (!isNaN(val)) {
                    setState(curr => {
                      return {
                        ...curr,
                        searchMsg: val
                      };
                    });
                  }
                }}
              />
            )} 
          />
        )}
      </div>
      <div className="d-flex col flex-column mt-3 mb-3 p-0">
        {/* <PerfectScrollbar className="col p-0"> */}
        <div className="col p-0">
          {(() => {
            if (state.filterStaff.length || state.searchMsg)
              return <FilterStaffList></FilterStaffList>;
            if (
              state.currBranch &&
              state.currGroup &&
              state.currShow === 'selectStaff'
            )
              return <StaffList></StaffList>;
            if (state.currBranch && state.currShow === 'selectGroup')
              return <GroupList></GroupList>;
            if (
              !state.currBranch &&
              !state.currGroup &&
              state.currShow === 'selectBranch'
            )
              return <BranchList></BranchList>;
          })()}
        </div>
        {/* </PerfectScrollbar> */}
      </div>
      <div className="d-flex justify-content-center">
        {state.currShow !== 'selectBranch' ? (
          <CusButton.White
            className={`mt-3 mb-3 p-3 pl-5 pr-5 col col-sm-auto${state.currBranch && state.currShow === 'selectGroup' ?
              ' staff-check-step2-group-back' : state.currBranch && state.currGroup && state.currShow === 'selectStaff' ?
                ' staff-check-step2-staff-back' : ''}`}
            children={
              <FormattedMessage id="pages.staffCheckOrder.step1.buttonBack" />
            }
            onClick={() => {
              if (state.filterStaff.length || state.searchMsg) {
                setState(curr => {
                  return {
                    ...curr,
                    searchMsg: ''
                  };
                });
              } else if (state.currShow === 'selectStaff') {
                setState(curr => {
                  return {
                    ...curr,
                    currShow: 'selectGroup',
                    currStaff: '',
                    currGroup: '',
                    staffInfo: []
                  };
                });
              } else if (state.currShow === 'selectGroup') {
                setState(curr => {
                  return {
                    ...curr,
                    currShow: 'selectBranch',
                    currBranch: '',
                    currStaff: '',
                    currGroup: '',
                    groupInfo: []
                  };
                });
                dispatchGlobal({
                  type: 'UPDATE',
                  payload: [
                    {
                      key: 'staffInfo',
                      val: {
                        ...globalState.staffInfo,
                        checkOrderBranch: null
                      }
                    }
                  ]
                });
              }
            }}
          />
        ) : null}
      </div>
    </>
  );
}

export default withRouter(StaffCheckStep_1);
